/**
 * Created by Alex Aguilar on 7/14/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('specialFlightsCtrl', specialFlightsCtrl);

    specialFlightsCtrl.$inject = ['$timeout', 'tabAdminFlights', 'loadFormCreate', 'messageService', 'routeService',
        'structureSeatMapService', 'boardingGateService', 'flightTimeService', 'flightService', 'linkService', 'dateService',
        'timeService', 'moment', 'datePickerService', '$filter', 'AuthServerProvider'];

    function specialFlightsCtrl($timeout, tabAdminFlights, loadFormCreate, messageService, routeService, structureSeatMapService,
                                boardingGateService, flightTimeService, flightService, linkService, dateService,
                                timeService, moment, datePickerService, $filter, AuthServerProvider){
        var vm = this;
        vm.tabs = tabAdminFlights;
        vm.typeFlights = typeFlights();
        vm.routes = (loadFormCreate.data._embeddeds.routes) ? loadFormCreate.data._embeddeds.routes : [];
        vm.structures = (loadFormCreate.data._embeddeds.structures) ? loadFormCreate.data._embeddeds.structures : [];
        vm.tomorrow = new Date();
        vm.tomorrow.setHours(0,0,0,0);
        vm.specialFlightForm = {
            'stretches': [],
            'segmentRoutes': [],
            'stretchRoutes': [],
            'aircrafts': [],
            'boardingGates': [],
            'datePickerOpenStatus': [],
            'stateFlight': true
        };

        vm.datePickerOpenStatus = {
            'dateFrom': false,
            'dateTo': false
        };
        vm.datePickerService = datePickerService;
        vm.userAccount = AuthServerProvider.getUserAccount();

        vm.datepickerSpecial = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.tomorrow
            },
            closed: function(args, index) {
                vm.specialFlightForm.stretches[index].arrivalDate = args.closeDate;
                if(index == 0){
                    vm.specialFlightForm.stretches[index].minDate = vm.tomorrow;
                }

            },
            open: function(index){
                if(vm.specialFlightForm.stretches[index].minDate == undefined){
                    if(index == 0){
                        vm.specialFlightForm.stretches[index].minDate = vm.tomorrow;
                        vm.datepickerSpecial.datepickerOptions.minDate = vm.tomorrow;
                    }else{
                        vm.specialFlightForm.stretches[index].minDate = vm.specialFlightForm.stretches[index-1].arrivalDate;
                        vm.datepickerSpecial.datepickerOptions.minDate = vm.specialFlightForm.stretches[index-1].arrivalDate;
                    }
                }else{
                    vm.datepickerSpecial.datepickerOptions.minDate = vm.specialFlightForm.stretches[index].minDate;
                }
            }
        };

        vm.cancel = function(){
            linkService.reloadRoute('specialFlights', null);
        }

        vm.openCalendar = function(index) {
            vm.specialFlightForm.datePickerOpenStatus[index].open = true;
        };

        vm.getSegments = function(routeId){
            if(routeId !=  undefined){
                vm.specialFlightForm.stretches = [];
                routeService.getRouteDetail(routeId)
                    .then(function(response){
                        vm.specialFlightForm.stretchRoutes = (response.data._embedded.stretchRoutes) ? response.data._embedded.stretchRoutes : [];
                        vm.specialFlightForm.segmentRoutes = (response.data._embedded.segmentRoutes) ? response.data._embedded.segmentRoutes : [];
                        vm.specialFlightForm.routeName = response.data.name;
                        getDatePickerOpenStatus(vm.specialFlightForm.stretchRoutes);
                        getBoardignGate(vm.specialFlightForm.stretchRoutes);
                    }, function(){
                        messageService.findAllError();
                    });
            }else{
                vm.specialFlightForm.stretchRoutes = [];
                vm.specialFlightForm.stretches = [];
            }
        }

        vm.getAircrafts = function(structure){
            /*if(structure != undefined){
                var makerId = structure._embedded.modelAircraft.makerId,
                    modelId = structure._embedded.modelAircraft.modelAircraftId,
                    originAirportId = vm.specialFlightForm.stretches[index].originAirportId,
                    destinyAirportId= vm.specialFlightForm.stretches[index].destinyAirportId;

                structureService.getAircraftByStructure(structure.structureId)
                    .then(function(response){
                        vm.specialFlightForm.aircrafts[index] = response;
                    });

                flightTimeService.getFlightTimesByStructureAndStretch(makerId, modelId, originAirportId, destinyAirportId)
                    .then(function (response) {
                        vm.specialFlightForm.stretches[index].flightTime = timeService.convertTimeToHourMinutes(response.data.time);
                    });
            }else{
                vm.specialFlightForm.stretches[index].aircrafts = [];
                vm.specialFlightForm.stretches[index].flightTime = undefined;
            }*/

            angular.forEach(vm.specialFlightForm.stretches, function(stretches, index) {
                if (structure != undefined) {
                    vm.specialFlightForm.stretches[index].structure = structure;
                    var makerId = structure._embedded.modelAircraft.makerId,
                        modelId = structure._embedded.modelAircraft.modelAircraftId,
                        originAirportId = vm.specialFlightForm.stretches[index].originAirportId,
                        destinyAirportId = vm.specialFlightForm.stretches[index].destinyAirportId;
                    structureSeatMapService.getAircraftByStructure(structure.structureId)
                        .then(function (response) {
                            vm.specialFlightForm.aircrafts[index] = response;
                            vm.specialFlightForm.stretches[index].aircrafts = response;
                        });

                    flightTimeService.getFlightTimesByStructureAndStretch(makerId, modelId, originAirportId, destinyAirportId)
                        .then(function (response) {
                            vm.specialFlightForm.stretches[index].flightTime = timeService.convertTimeToHourMinutes(response.data.time);
                        });
                } else {
                    vm.specialFlightForm.stretches[index].structure = undefined;
                    vm.specialFlightForm.stretches[index].aircrafts = [];
                    vm.specialFlightForm.aircrafts[index] = [];
                    vm.specialFlightForm.stretches[index].flightTime = undefined;
                }
            })
        }


        vm.getBoardingGates = function(airport, index){
            if(airport != undefined){
                var airportId = linkService.getLinkId(airport._links.self.href)
                boardingGateService.getBoardingGatesByAirport(airportId)
                    .then(function(response){
                        vm.specialFlightForm.boardingGates[index] = response.data._embedded.boardinggates;
                    }).catch(function(error){
                        messageService.findAllError('');
                    })
            }
        }

        vm.updateArrivalDate = function(departureDate, event, index, stretchRoutesLength){

            /*$timeout(function(){
                var element = $(event.target),
                    valueDate = vm.specialFlightForm.stretches[index].departureDate;
                vm.specialFlightForm.stretches[index].departureDate = valueDate;
                vm.specialFlightForm.stretches[index].arrivalDate = valueDate;

            }, 100);*/
        }

        vm.updateArrivalDateTime = function(pos){
            angular.forEach(vm.specialFlightForm.stretches, function(stretches, index) {
                if(vm.specialFlightForm.stretches[index].departureDateTime != undefined) {
                    $timeout(function () {
                        var newTimeKey = "00:00";
                        if (vm.specialFlightForm.stretches[index].flightTime != undefined) {
                            newTimeKey = vm.specialFlightForm.stretches[index].flightTime;
                        }

                        var newTime = timeService.calculateSumTimes(vm.specialFlightForm.stretches[index].departureDateTime, newTimeKey);
                        vm.specialFlightForm.stretches[index].arrivalDateTime = newTime;

                        if (vm.specialFlightForm.stretches[index].departureDate != undefined) {
                            vm.specialFlightForm.stretches[index].arrivalDate =
                                changeDay(vm.specialFlightForm.stretches[index].departureDateTime,
                                    vm.specialFlightForm.stretches[index].arrivalDateTime,
                                    vm.specialFlightForm.stretches[index].departureDate);
                        }

                        if (vm.specialFlightForm.stretches[index + 1] != undefined &&
                            vm.specialFlightForm.stretches[index + 1].departureDateTime != undefined) {
                            if (
                                (parseInt(vm.specialFlightForm.stretches[index].arrivalDateTime.replace(':', '')) >
                                parseInt(vm.specialFlightForm.stretches[index + 1].departureDateTime.replace(':', '')))) {
                                vm.specialFlightForm.stretches[index + 1].departureDateTime = vm.specialFlightForm.stretches[index].arrivalDateTime;
                            }
                        }

                        if (index > 0) {
                            vm.specialFlightForm.stretches[index].minDate = vm.specialFlightForm.stretches[index - 1].arrivalDate;
                        }
                    }, 100);
                }
            });

            if(vm.specialFlightForm.stretches[pos].departureDateTime != undefined) {
                $timeout(function () {
                    for (var i = pos + 1; i < vm.specialFlightForm.stretches.length; i++) {
                        if (vm.specialFlightForm.stretches[i].departureDateTime != undefined) {
                            if (new Date(vm.specialFlightForm.stretches[i - 1].arrivalDate).getTime() >
                                new Date(vm.specialFlightForm.stretches[i].departureDate).getTime()) {
                                vm.specialFlightForm.stretches[i].departureDate = vm.specialFlightForm.stretches[i - 1].arrivalDate;
                            }
                            vm.specialFlightForm.stretches[i].arrivalDate =
                                changeDay(vm.specialFlightForm.stretches[i].departureDateTime,
                                    vm.specialFlightForm.stretches[i].arrivalDateTime,
                                    vm.specialFlightForm.stretches[i].departureDate);
                            vm.specialFlightForm.stretches[i].minDate = vm.specialFlightForm.stretches[i - 1].arrivalDate;
                        }
                    }
                }, 100);
            }
        }

        vm.saveSpecialFlight = function(isValid, specialFlightForm){
            if(isValid){
                var saveForm = {
                    "flightNumber": specialFlightForm.flightNumber,
                    "routeId": specialFlightForm.routeId,
                    "type": specialFlightForm.typeFlight,
                    "active": specialFlightForm.stateFlight,
                    "departureFlights": getDepartureFlights(specialFlightForm)
                };
                flightService.saveSpecialFlight(saveForm, vm.userAccount.userName)
                    .then(function(response){
                        linkService.reloadRoute('adminFlights');
                    });
            }
        }

        function getDepartureFlights(specialFlightForm){
            var departureFlights = [];
            angular.forEach(specialFlightForm.stretches, function(stretch, index){
                var aircraftId = linkService.getLinkId(specialFlightForm.aircrafts[index].aircraft._links.self.href),
                    boardingGateId = linkService.getLinkId(stretch.boardingGate._links.self.href),
                    structureId = stretch.structure.structureId,
                    departureDate = dateService.convertDateToTimeTwo($filter('date')(stretch.departureDate, "yyyy-MM-dd"),
                        stretch.departureDateTime),
                    arrivalDate = dateService.convertDateToTimeTwo($filter('date')(stretch.arrivalDate, "yyyy-MM-dd"),
                        stretch.arrivalDateTime),
                    originAirportId = stretch.originAirportId,
                    destinyAirportId = stretch.destinyAirportId,
                    order = stretch.order;

                departureFlights.push({
                    "departureDate": departureDate,
                    "arrivalDate": arrivalDate,
                    "boardingGateId": parseInt(boardingGateId),
                    "order": order,
                    "aircraftId": parseInt(aircraftId),
                    "structureId": structureId,
                    "originAirportId": originAirportId,
                    "destinyAirportId":destinyAirportId,
                    "segmentFlights": []
                });

                angular.forEach(specialFlightForm.segmentRoutes, function(segmentRoute){
                    var segmentOriginAirportId = segmentRoute._embedded.segment.originAirportId,
                        segmentDestinyAirportId = segmentRoute._embedded.segment.destinyAirportId;
                    if(originAirportId == segmentOriginAirportId){
                        departureFlights[index].segmentFlights.push({
                            "arrivalDate": arrivalDate,
                            "destinyAirportId": segmentDestinyAirportId,
                            "originAirportId": segmentOriginAirportId,
                            "departureDate": departureDate
                        })
                    }
                });
            });
            return getArrivalDateFlights(departureFlights,departureFlights);
        }

        function getArrivalDateFlights(departureFlights1,departureFlights2){
            angular.forEach(departureFlights1, function(departureFlight1){
                angular.forEach(departureFlight1.segmentFlights, function(segmentflight){
                    angular.forEach(departureFlights2, function(departureFight2){
                        if(segmentflight.destinyAirportId==departureFight2.destinyAirportId){
                            segmentflight.arrivalDate = departureFight2.arrivalDate;
                        }
                    });
                });
            });
            return departureFlights1;
        }

        vm.autoCompleteAircraft = function(aircraft){
            angular.forEach(vm.specialFlightForm.stretchRoutes, function(stretchRoute, iterator){
                vm.specialFlightForm.aircrafts[iterator].aircraft = aircraft;
            });
        }

        function getDatePickerOpenStatus(stretchRoutes){
            var stretchRoutesLength = stretchRoutes.length;
            for(var i = 0; i < stretchRoutesLength; i++){
                vm.specialFlightForm.datePickerOpenStatus.push({'open': false});
            }
        }

        function getBoardignGate(stretchRoutes){
            angular.forEach(stretchRoutes, function(stretchRoute, index) {
                boardingGateService.getBoardingGatesByAirport(stretchRoute.originId)
                    .then(function(response){
                        vm.specialFlightForm.boardingGates[index] = response.data._embedded.boardinggates;
                    })
            });
        }

        function typeFlights(){
            return [
                {'code': "S", 'name': "air.specialFlight.types.special"},
                {'code': "C", 'name': "air.specialFlight.types.charter"},
                {'code': "U", 'name': "air.specialFlight.types.location"}
            ];
        }

        function changeDay(timeDeparture, timeArrival, dateArrival){
            var timeDepartureSplit = timeDeparture.split(":"),
                timeArrivalSplit = timeArrival.split(":");
            if(parseInt(timeDepartureSplit[0])>parseInt(timeArrivalSplit[0])){
                dateArrival = new Date((dateArrival).getTime() + (1*24*60*60*1000));
            }
            return dateArrival;
        }

    }

})();
